import { Component, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';

import { StartupSpinnerComponent } from '@plugins/client/spinners';
import { FeatureTranslationModule } from '@plugins/client/translation';
import { setWindowTitleFromJWT } from '@plugins/shared/utils/title-from-jwt';

@Component({
  selector: 'shareprice-root',
  standalone: true,
  imports: [RouterModule, StartupSpinnerComponent],
  template: `
    <router-outlet></router-outlet>
    <plugins-startup-spinner></plugins-startup-spinner>
  `,
})
export class AppComponent extends FeatureTranslationModule implements OnInit {
  ngOnInit() {
    setWindowTitleFromJWT();
  }
}
